const SET_HEART_UPDATE_WIDGET_DATA = 'SET_HEART_UPDATE_WIDGET_DATA';

export {
  SET_HEART_UPDATE_WIDGET_DATA
};

